import { j as o } from "./kezios-design-system.esm172.js";
import { IconComponent as e } from "./kezios-design-system.esm4.js";
const c = (r) => /* @__PURE__ */ o.jsxs(e, { ...r, viewBox: "0 0 24 24", fill: "none", children: [
  /* @__PURE__ */ o.jsx(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10Z"
    }
  ),
  /* @__PURE__ */ o.jsx(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M9.5 8.9653c0-.4772 0-.7159.0997-.8491a.5.5 0 0 1 .3647-.1991c.166-.0118.3667.1172.7682.3753l4.7206 3.0347c.3484.2239.5226.3359.5827.4783a.4997.4997 0 0 1 0 .3892c-.0601.1424-.2343.2544-.5827.4783l-4.7206 3.0347c-.4015.2581-.6022.3872-.7682.3753a.5.5 0 0 1-.3647-.1991C9.5 15.7506 9.5 15.512 9.5 15.0347V8.9653Z"
    }
  )
] });
export {
  c as IconPlayCircle
};
